import React from 'react'
import ManagePlansContainer from './ManagePlansContainer'

const ManagePlans = (props) => (
  <ManagePlansContainer {...props} />
)

export default ManagePlans



// WEBPACK FOOTER //
// src/routes/ManagePlans/index.js